import './demand-page.component.scss';
import { useFilterPanelSelection } from '../../components/filters/hooks/use-filter-panel-selection.hook';
import { AppForceSelectionModal } from './components/app-force-selection.modal';
import { useAppForceSelection } from './components/hooks/use-app-force-selection.hook';
import LandingComponent from './landing/landing.component';

export const DemandPageComponent = () => {
  const { enabled, handleForceSelClose, showPopup } = useAppForceSelection();
  const filterSelection = useFilterPanelSelection();
  return (
    <>
      <LandingComponent
        reportName="landing"
        filterSelection={filterSelection}
        enabled={enabled}
      />

      <AppForceSelectionModal
        filterSelection={filterSelection}
        onClose={handleForceSelClose}
        show={showPopup}
        enabled={enabled}
        title="Select Market"
      />
    </>
  );
};

export default DemandPageComponent;
